module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_09A.b94fcde1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_09A.mp3
// module id = 120
// module chunks = 0